export const CI_VERDICT_OPTIONS = [
  { label: 'Strong Buy', value: 'Strong Buy' },
  { label: 'Fairly Priced', value: 'Fairly Priced' },
  { label: 'Trophy Asset', value: 'Trophy Asset' },
  { label: 'Negotiate', value: 'Negotiate Aggressively' },
] as const;

/** Standalone plots have no undivided land share, regardless of stored CI values. */
export function matchesUdsPropertyType(property: any, filters: any): boolean {
  if (!filters?.udsSupportAbove) return true;
  const ci = property?.ciRecord ?? {};
  const types = [property?.propertyType, property?.propertyCategory, property?.listingType,
    property?.ciPropertyType, ci.propertyType, ci.propertyCategory, ci.ciPropertyType];
  return !types.some(value => {
    const type = String(value ?? '').replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
    return /\b(plots?|land|farmland)\b/.test(type) || type.replace(/[^a-z]/g, '') === 'plotland';
  }) && !(ci.landAssessment && ci.landAssessment.builtUpArea == null);
}
export const ADVANCED_CI_FILTERS = [
  { label: 'Rental Yield > 3%', value: 'rentalYieldAbove' },
  { label: 'Priced Below Benchmark', value: 'pricedBelowBenchmark' },
  { label: 'UDS Support > 70%', value: 'udsSupportAbove' },
] as const;

/** Never forward unknown verdicts or paid criteria from an unpaid URL. */
export function sanitizeCiSearchFilters(data: any, paidCi: boolean): any {
  const result = { ...data };
  const verdicts = Array.isArray(data?.ciVerdict) ? data.ciVerdict : data?.ciVerdict ? [data.ciVerdict] : [];
  result.ciVerdict = [...new Set(verdicts.filter((value: string) => CI_VERDICT_OPTIONS.some(option => option.value === value)))];
  if (!result.ciVerdict.length) delete result.ciVerdict;
  for (const option of ADVANCED_CI_FILTERS) {
    delete result[option.value];
    if (paidCi && (data?.[option.value] === true || data?.[option.value] === 'true' ||
      (option.value === 'rentalYieldAbove' && Number(data?.[option.value]) === 3) ||
      (option.value === 'udsSupportAbove' && Number(data?.[option.value]) === 70))) {
      result[option.value] = option.value === 'rentalYieldAbove' ? 3 : option.value === 'udsSupportAbove' ? 70 : true;
    }
  }
  const types = Array.isArray(result.propertyType) ? result.propertyType : [result.propertyType];
  if (types.some((type: unknown) => /^plots?$/i.test(String(type ?? '').trim()))) delete result.udsSupportAbove;
  return result;
}
